import { Component, ElementRef, Inject, NgZone, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'roaming-terms-and-conditions',
  templateUrl: './roaming-terms-and-conditions.component.html',
  styleUrls: ['./roaming-terms-and-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RoamingTermsAndConditionsComponent implements OnInit {
  @ViewChild('iframe', { static: false }) iframe: ElementRef;

  url: string = 'assets/terms_and_conditions/current/Terms_and_Conditions.html';
  scrollBottom = false;
  scroll$: any = null;

  constructor(
    @Inject(NgZone) private zone: NgZone,
    public dialogRef: MatDialogRef<RoamingTermsAndConditionsComponent>
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.iframe.nativeElement.setAttribute('src', this.url);
  }

  close(accepted = false) {
    this.dialogRef.close(accepted);
  }

  onFrameLoad() {
    const iframe = this.iframe.nativeElement;
    const hasVScrollbar = iframe.contentDocument.documentElement.scrollHeight > iframe.clientHeight;

    this.scrollBottom = !hasVScrollbar;
    this.scroll$ = fromEvent(this.iframe.nativeElement.contentWindow, 'scroll').subscribe(() => {
      this.onScroll();
    });
  }

  onScroll() {
    const iframeWindow = this.iframe.nativeElement.contentWindow;
    const iframeDocument = this.iframe.nativeElement.contentDocument;
    const scrollHeight = iframeDocument.documentElement.scrollHeight;

    if (Math.ceil(iframeWindow.scrollY + iframeWindow.innerHeight) >= scrollHeight) {
      this.zone.run(() => {
        this.scrollBottom = true;
      });
    }
  }

  NgOnDestroy() {
    this.scroll$.unsubscribe();
  }
}
